import { render, staticRenderFns } from "./two-step-verification-2.vue?vue&type=template&id=19a475d2&scoped=true"
import script from "./two-step-verification-2.vue?vue&type=script&lang=js"
export * from "./two-step-verification-2.vue?vue&type=script&lang=js"
import style0 from "./two-step-verification-2.vue?vue&type=style&index=0&id=19a475d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a475d2",
  null
  
)

export default component.exports